import React, { useEffect } from 'react'
import { EditPageHeader } from '../../components/EditPageHeader'
import { useState } from 'react'
import * as API from "../../framework/API/api";
import { ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from '../../framework/constant/constant';
import { utility } from '../../framework/utility/utilityProvider';
import { useTranslation } from '../../locale/useTranslation';
import { ImageBrowser } from '../../framework/forms/helpercomponents/selectFile/ImageBrowser';
import BossDialog from '../../components/BossDialog';
import { Switch } from '@mui/material';
import moment from 'moment';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import AddRoundButton from '../../framework/forms/helpercomponents/buttons/AddRoundButton';
import DeleteRoundButton from '../../framework/forms/helpercomponents/buttons/DeleteRoundButton';
import { ConfirmDeleteAlert } from '../../ConfirmAlert';
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import NodeTreeViewForm from '../MediaLibrary/NodeTreeView/NodeTreeViewForm';
import ToastNotification from '../../components/ToastNotification';

const ProviderEditForm = (props) => {

  const lang = useTranslation();
  const blankDataItem = {
    ...props?.item,
    SID: props?.item?.SID ?? 0,
    Description: props?.item?.Description ?? '',
    LogoUrl: props?.item?.LogoUrl ?? '',
    StartDate: props?.item?.StartDate ? utility.convertMilisecondsToDateString(props?.item?.StartDate, 'YYYY-MM-DD') : moment().format("YYYY-MM-DD"),
    EndDate: props?.item?.EndDate ? utility.convertMilisecondsToDateString(props?.item?.EndDate, 'YYYY-MM-DD') : moment().add(7, 'days').format("YYYY-MM-DD"),
    Archive: props?.item?.Archive ?? false,
    IsDefault: props?.item?.IsDefault ?? false,
    IsActive: props?.item?.IsActive ?? false,
    TBA: props?.item?.TBA ?? false,
    DeeplinkUrl: props?.item?.DeeplinkUrl ?? ""
  }

  const [dataItem, setDataItem] = useState(blankDataItem);
  const [imageFiles, setImageFiles] = useState(new Set());
  const [tabNumber, setTabNumber] = React.useState("1");
  const [showNodeTreeViewForm, setShowNodeTreeViewForm] = useState(false);
  const [nodeGridData, setNodeGridData] = useState([]);

  useEffect(() => {
    if (props.item._id) {
      loadData();
    }
  }, []);

  const loadData = async () => {
    const nodesRes = await API.getData(ENTITYNAME.Nodes, { query: ["Providers", "in", [props.item._id]] });
    setNodeGridData(nodesRes?.data ?? []);
  };

  const handleTabChange = (event, newValue) => {
    setTabNumber(`${newValue}`);
  };

  const isValid = () => {
    if (dataItem.Description == "" || dataItem.Description == undefined) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_name_error_message });
      return false;
    }

    if (dataItem.LogoUrl == "" || dataItem.LogoUrl == undefined) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_image_url_error_message });
      return false;
    }
    return true;
  }

  const handleSubmit = async () => {

    if (!isValid()) return;

    let LogoUrl = dataItem.LogoUrl;
    if (imageFiles.size > 0) {
      let resUrl = await API.uploadImage(imageFiles);
      if (!resUrl.success) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.upload_fail_error_message });
        return;
      }
      LogoUrl = resUrl.data
      dataItem.LogoUrl = LogoUrl
    }

    const data = {
      _id: dataItem?._id,
      SID: dataItem?.SID,
      Description: dataItem?.Description,
      LogoUrl: LogoUrl,
      StartDate: dataItem?.StartDate ? utility.convertStringDatetoMilliseconds(dataItem?.StartDate) : null,
      EndDate: dataItem?.EndDate ? utility.convertStringDatetoMilliseconds(dataItem?.EndDate) : null,
      Archive: dataItem?.Archive ?? false,
      IsDefault: dataItem?.IsDefault ?? false,
      IsActive: dataItem?.IsActive ?? false,
      TBA: dataItem?.TBA ?? false,
      DeeplinkUrl: dataItem?.DeeplinkUrl,
      checkDuplicate: true,
      query: ["Description", "=", dataItem.Description]
    }
    console.log(data)
    let res = await API.saveData(ENTITYNAME.OttProvider, data);
    if (dataItem?.IsDefault) {
      await API.setAsDefault(ENTITYNAME.OttProvider, data._id);
    }
    if (res.success) {

      if (nodeGridData?.length > 0) {
        let updateNodes = [];

        for (const node of nodeGridData) {
          const existingProviders = node?.Providers || [];
          const newProviderId = res.data._id.toString();
          const updatedProviders = [...new Set([...existingProviders, newProviderId])];
          if (updatedProviders.length !== existingProviders.length) {
            updateNodes.push({ _id: node._id, Providers: updatedProviders });
          }
        }
        await API.saveData(ENTITYNAME.Nodes, updateNodes);
      }

      let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.OTT_PROVIDER, data: res.data, message: res.message };
      API.SaveLogs(logData);
      utility.deleteLocalStorageItem(ENTITYNAME.OttProvider);
      props.cancelEdit();
      props.refresh();
      return;
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
  }

  const onChange = (e) => {
    if (e.target.name == 'Archive') {
      setDataItem({ ...dataItem, Archive: !dataItem.Archive });
    }
    else if (e.target.name == 'IsActive') {
      setDataItem({ ...dataItem, IsActive: !dataItem.IsActive })
    }
    else if (e.target.name === 'TBA') {
      setDataItem({ ...dataItem, TBA: !dataItem.TBA })
    }
    else if (e.target.name == 'IsDefault') {
      setDataItem({ ...dataItem, IsDefault: !dataItem.IsDefault });
    }
    else {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value })
    }
  }

  const handleChange = (e) => {
    if (e.target.name === 'LogoUrl' && e.target?.files) {
      if (e.target.files !== undefined) {
        setImageFiles(e.target.files[0]);
      } else {
        setImageFiles(new Set());
      }
    }
    setDataItem({ ...dataItem, [e.target.name]: e.target.value });
  };

  const handleSelectedNodes = (nodes) => {
    if (!nodes?.length) return;

    setNodeGridData((prev) => {
      const existingNodeIds = new Set(prev.map((n) => n._id.toString()));
      const duplicateNodes = nodes.filter((node) => existingNodeIds.has(node._id.toString()));
      const newNodes = nodes.filter((node) => !existingNodeIds.has(node._id.toString())).map((node) => ({
        ...node,
        Providers: node?.Providers?.length ? [...new Set(node.Providers)] : []
      }));
      if (duplicateNodes.length > 0) {
        const duplicateNames = duplicateNodes.map((node) => node.Name).join(", ");
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Node already added: ${duplicateNames}` });
      }
      return newNodes.length > 0 ? [...prev, ...newNodes] : prev;
    });

    setShowNodeTreeViewForm(false);
  };

  const deleteNodeGridData = async (selectedNode) => {
    const providerId = dataItem?._id?.toString();
    const updatedProviders = selectedNode?.Providers?.filter((id) => id !== providerId);
    await API.saveData(ENTITYNAME.Nodes, { ...selectedNode, Providers: updatedProviders });
    setNodeGridData((prev) => prev.filter((node) => node._id !== selectedNode._id));
    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.delete_successfully_grid_data_success_toast_message });
  };

  const MyCommandCell = ({ dataItem }) => (
    <td style={{ padding: "4px" }}>
      <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => deleteNodeGridData(dataItem), () => { })} />
    </td>
  );

  return (
    <div>
      <BossDialog
        title={props.item.Description ?? `${lang.create_provider_dialog_header}`}
        onClose={props.cancelEdit}
        width='900px'
      >
        <EditPageHeader title='' onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
        <div className='row'>
          <div className='col-12'>
            <div className='row mt-2'>
              <div className='col-6'>
                <label htmlFor='Description'>{lang.name_label}*</label>
                <input className="form-control form-control-sm" type='text' name='Description' value={dataItem.Description} onChange={onChange} />
              </div>
              <div className="col-6">
                <label htmlFor="">{lang.deeplink_url_label}</label>
                <input type="text" className="form-control form-control-sm" name="DeeplinkUrl" value={dataItem.DeeplinkUrl} onChange={(e) => onChange(e)} />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12">
                <label>{lang.image_url_label} *</label>
                <ImageBrowser name='LogoUrl' value={dataItem.LogoUrl} onChange={handleChange} hidePosterLibrary={true} setSelectedImage={setImageFiles} />
              </div>
            </div>
            <div className='row mt-2'>
              <div className='col-5'>
                <label>{lang.start_date_label}</label>
                <input type='date' name='StartDate' className='form-control form-control-sm' value={dataItem.StartDate} onChange={onChange} />
              </div>
              <div className='col-5'>
                <label>{lang.end_Date_label}</label>
                <input type='date' name='EndDate' className='form-control form-control-sm' value={dataItem.EndDate} onChange={onChange} disabled={dataItem.TBA} />
              </div>
              <div className='col-2' style={{ marginTop: "22px" }}>
                <input
                  type='checkbox'
                  name='TBA'
                  checked={dataItem.TBA}
                  value={dataItem.TBA}
                  onClick={onChange}
                  className='mt-1'
                />
                <label className='ml-2'>{lang.tba_label}</label>
              </div>
            </div>
            <div className='row' style={{ marginTop: "17px" }}>
              <div className='col-4' style={{ marginTop: "-6px" }}>
                <Switch
                  name='IsActive'
                  label={lang.status_label}
                  onChange={(e) => onChange(e)}
                  checked={dataItem?.IsActive}
                  value={dataItem?.IsActive}
                  size='medium'
                />
                <label className={dataItem.IsActive ? "pl-1 text-success" : "pl-1 text-danger"}>{lang.active_label}</label>
              </div>
              <div className='col-4'>
                <input type='checkbox'
                  name='Archive'
                  value={dataItem.Archive}
                  checked={dataItem.Archive}
                  onClick={onChange}
                  className='mt-1'
                />
                <label className='ml-2'>{lang.archive}</label>
              </div>
              <div className='col-4'>
                <input
                  type='checkbox'
                  name='IsDefault'
                  value={dataItem.IsDefault}
                  checked={dataItem.IsDefault}
                  onClick={onChange}
                  className='mt-1'
                />
                <label className='ml-2'>{lang.is_default_label}</label>
              </div>
            </div>
          </div>
        </div>
        {props?.item?._id &&
          <div className="row mt-2">
            <div className='col-12'>
              <Box sx={{ width: '100%', typography: 'body1' }}>
                <TabContext value={tabNumber}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleTabChange} aria-label="tabs example">
                      <Tab label={lang.node_label} value="1" />
                    </TabList>
                  </Box>
                  <TabPanel value={"1"}>
                    <div className='row'>
                      <div className="col-12">
                        <AddRoundButton onClick={() => setShowNodeTreeViewForm(true)} />
                        <span className='float-right' style={{ marginTop: "15px" }}>{lang.node_label}</span>
                        <Grid style={{ height: "25vh", marginTop: "5px" }} data={nodeGridData} resizable={true}>
                          <GridColumn editable={false} cell={MyCommandCell} width="40px" />
                          <GridColumn field="CSID" title={lang.node_csid_label} editable={false} width={200} />
                          <GridColumn field="Name" title={lang.name_column} editable={false} width={200} />
                          <GridColumn field="ParentNode" title={lang.parent_node_column} editable={false} width={200} />
                          <GridColumn field="ExternalReference" title={lang._external_refrence_column} editable={false} width={200} />
                          <GridColumn field="Catalogue.Description" title={lang.catalogue_column} editable={false} width={200} />
                          <GridColumn field="TranslatedDescription" title={lang.translated_description_column} editable={false} width={200} />
                          <GridColumn field="ParentalRating.Description" title={lang.parental_rating_column} editable={false} width={200} />
                        </Grid>
                      </div>
                    </div>
                  </TabPanel>
                </TabContext>
              </Box>
            </div>
          </div>}
        {props?.item?._id && showNodeTreeViewForm && <BossDialog title={lang.select_nodes_dialog_header} width='600px' onClose={() => setShowNodeTreeViewForm(false)}>
          <NodeTreeViewForm handleSelectedNodes={handleSelectedNodes} isSaveButton={true} isMultiSelect={true} onClose={() => setShowNodeTreeViewForm(false)} showCatalogue={false} isFromMedia={true} />
        </BossDialog>}
      </BossDialog>
    </div>
  )
}

export default ProviderEditForm